import { normaliseShipmentUnitInputField, convertShipmentUnitFromMetricToImperial } from "src/helpers";
import { IdGenerator } from "src/utils";
import {
  ShipmentUnit,
  ShipmentUnitInputField,
  UpdatePurchaseOrderShipmentDetailsFormData,
  PatchPurchaseOrderShipmentDetailsRequestBody,
  PurchaseOrder,
  UoM
} from "src/types";

export class UpdatePurchaseOrderShipmentDetailsMapper {
  public static initUpdatePurchaseOrderShipmentDetailsFormData(): UpdatePurchaseOrderShipmentDetailsFormData {
    return {
      purchaseOrderId: "",
      trackingNo: "",
      carrier: "",
      shipmentCost: "",
      importDutyCost: "",
      packingListFiles: [],
      shipmentUnits: [],
      additionalInfo: ""
    };
  }

  public static initShipmentUnitInputField(): ShipmentUnitInputField {
    return {
      fieldId: IdGenerator.generateUniqueElementId(),
      type: "",
      quantity: "",
      weight: "",
      length: "",
      width: "",
      height: ""
    };
  }

  public static updatePurchaseOrderShipmentDetailsFormDataFromPurchaseOrder(
    purchaseOrder: PurchaseOrder,
    shipmentUnitsUoM?: UoM,
    packingListFiles: File[] = []
  ): UpdatePurchaseOrderShipmentDetailsFormData {
    const shipmentUnits =
      shipmentUnitsUoM === "Imperial"
        ? purchaseOrder.shipmentUnits?.map(convertShipmentUnitFromMetricToImperial)
        : purchaseOrder.shipmentUnits;

    const shipmentUnitsFormData =
      shipmentUnits?.map(UpdatePurchaseOrderShipmentDetailsMapper.shipmentUnitInputFieldFromShipmentUnit) ?? [];

    return {
      purchaseOrderId: purchaseOrder.id,
      trackingNo: purchaseOrder.trackingNo ?? "",
      carrier: purchaseOrder.carrier ?? "",
      shipmentCost: purchaseOrder.shipmentCost?.toString() ?? "",
      importDutyCost: purchaseOrder.importDutyCost?.toString() ?? "",
      packingListFiles: packingListFiles,
      shipmentUnits: shipmentUnitsFormData,
      additionalInfo: purchaseOrder.additionalInfo?.shipmentNote?.body ?? ""
    };
  }

  public static shipmentUnitInputFieldFromShipmentUnit(shipmentUnit: ShipmentUnit): ShipmentUnitInputField {
    return {
      fieldId: IdGenerator.generateUniqueElementId(),
      type: shipmentUnit.type,
      quantity: shipmentUnit.quantity.toString(),
      weight: shipmentUnit.weight.toString(),
      length: shipmentUnit.length.toString(),
      width: shipmentUnit.width.toString(),
      height: shipmentUnit.height.toString()
    };
  }

  public static updatePurchaseOrderShipmentDetailsRequestBodyFromFormData(
    shipmentUnitInputField: UpdatePurchaseOrderShipmentDetailsFormData,
    initialShipmentUnitInputField?: UpdatePurchaseOrderShipmentDetailsFormData,
    shipmentUnitUoM?: UoM
  ): PatchPurchaseOrderShipmentDetailsRequestBody {
    const { trackingNo, carrier, shipmentCost, importDutyCost, shipmentUnits, additionalInfo } = shipmentUnitInputField;

    const normalisedTrackingNo =
      trackingNo === (initialShipmentUnitInputField?.trackingNo || "") ? undefined : trackingNo || null;
    const normalisedCarrier = carrier === (initialShipmentUnitInputField?.carrier || "") ? undefined : carrier || null;
    const normalisedShipmentCost =
      shipmentCost === (initialShipmentUnitInputField?.shipmentCost?.toString() || "")
        ? undefined
        : shipmentCost
          ? Number(shipmentCost)
          : null;
    const normalisedImportDutyCost =
      importDutyCost === (initialShipmentUnitInputField?.importDutyCost?.toString() || "")
        ? undefined
        : importDutyCost
          ? Number(importDutyCost)
          : null;
    const normalisedShipmentUnits = shipmentUnits.map(normaliseShipmentUnitInputField) || undefined;
    const normalisedShipmentNoteBody =
      !initialShipmentUnitInputField?.additionalInfo && !additionalInfo ? undefined : additionalInfo || null;

    return {
      trackingNo: normalisedTrackingNo,
      carrier: normalisedCarrier,
      shipmentCost: normalisedShipmentCost,
      importDutyCost: normalisedImportDutyCost,
      shipmentUnits: normalisedShipmentUnits.length ? normalisedShipmentUnits : undefined,
      shipmentNoteBody: normalisedShipmentNoteBody,
      shipmentUnitUoM: shipmentUnitUoM
    };
  }
}
